
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      {/* Línea superior con redes sociales en una sola fila */}
      <div className="footer-top">
        <div className="container d-flex justify-content-center align-items-center gap-4 flex-wrap py-1">
          <a href="https://www.facebook.com/geminisseguridad" target="_blank" rel="noopener noreferrer" className="social-link-horizontal">
            <FaFacebook />
            <span>@geminisseguridad</span>
          </a>
          <a href="https://www.instagram.com/geminisseguridad" target="_blank" rel="noopener noreferrer" className="social-link-horizontal">
            <FaInstagram />
            <span>@geminisseguridad</span>
          </a>
          <a href="https://www.linkedin.com/company/geminisseguridad" target="_blank" rel="noopener noreferrer" className="social-link-horizontal">
            <FaLinkedin />
            <span>@geminisseguridad</span>
          </a>
          <a href="https://www.youtube.com/@GeminisSeguridad" target="_blank" rel="noopener noreferrer" className="social-link-horizontal">
            <FaYoutube />
            <span>@geminisseguridad</span>
          </a>
          <a href="https://www.x.com/@GeminisSeguridad" target="_blank" rel="noopener noreferrer" className="social-link-horizontal">
            <FaXTwitter />
            <span>@Geminisuy</span>
          </a>
        </div>
      </div>

      {/* Cuerpo principal con 3 columnas */}
      <div className="footer-main py-4">
        <div className="container row text-center text-md-start">
          {/* Ubicación */}
          <div className="col-md-4 mb-3 d-flex">
            {/* Ubicación */}
            <div className="col-md-4">
              <h5>Ubicación</h5>
              <p>📍 Solís de Mataojo, Lavalleja</p>
              <p>📍 Migues, Canelones</p>
            </div>

            {/* Ubicación */}
            <div className="col-md-1"></div>
            <div className="col-md-7 ">
              <h5>Contacto</h5>
              
              <p className=''>
                📞 Contacto: <a href="tel:+59895849968" className="text-white"> <h6> 095 849 968 </h6> </a>
              </p>
              <p className=''>
                📞 <span className="text-warning">Monitoreo: </span>
                

                <a href="tel:08008909" className="mx-2 text-warning"> <h6> 0800 8909</h6></a>
              </p>
            </div>
          </div>
          {/* Logo */}
          <div className="col-md-4 mb-3 d-flex justify-content-center align-items-center">
            <img src="/img/logos/logo_nobg.png" alt="Logo GÉMINIS SEGURIDAD" className="footer-logo-large" />
          </div>

          {/* Enlaces útiles */}
          <div className="col-md-4 mb-3">
            <h5>Enlaces útiles</h5>
            <ul className="list-unstyled">
              <li className="nav-item">
                <Link className="nav-link" to="/">Inicio</Link>
              </li>
              <li className="nav-item">

                <Link className="nav-link" to="/productos">Productos</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/servicios">Servicios</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/descargas">Descargas</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contacto">Contacto</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Pie de página inferior */}
      <div className="footer-bottom text-center py-2">
        <p>&copy; 2025 GÉMINIS SEGURIDAD. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;
